import { render } from "./removeFromGroups.vue?vue&type=template&id=4579f523"
import script from "./removeFromGroups.vue?vue&type=script&lang=js"
export * from "./removeFromGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__